import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'app-inventory-resource-pixels',
    templateUrl: './resource-pixels.component.pug',
    styleUrls: ['./resource-pixels.component.less']
})
export class ResourcePixelsComponent {
    @Input() data: any = {};

    constructor(
    ) {
    }
}
